import React, { useContext } from 'react'
import ButtonToggle from '../../../../../common/ButtonToggle'
import { ConnectorPinsContext } from '../../context/context'

export const SELECT_DB_LEVEL = 'SELECT_DB_LEVEL'
export const SELECT_CODE_LEVEL = 'SELECT_CODE_LEVEL'

const FILTER_CONNECTORS_QUERY_TYPE = {
  dbLevel: 'db_level',
  codeLevel: 'code_level',
}

const FilterConnectorsToggle = () => {
  const [state, dispatch] = useContext(ConnectorPinsContext)
  const selectDbLevel = () => {
    dispatch({
      type: 'query_type',
      data: FILTER_CONNECTORS_QUERY_TYPE.dbLevel,
    })

    return {
      type: SELECT_DB_LEVEL,
      queryType: FILTER_CONNECTORS_QUERY_TYPE.dbLevel,
    }
  }
  const selectCodeLevel = () => {
    dispatch({
      type: 'query_type',
      data: FILTER_CONNECTORS_QUERY_TYPE.codeLevel,
    })
    return {
      type: SELECT_CODE_LEVEL,
      queryType: FILTER_CONNECTORS_QUERY_TYPE.codeLevel,
    }
  }

  return (
    <ButtonToggle
      className={'flex items-stretch px-6 my-4'}
      selectedValue={state?.query_type}
      startValue={FILTER_CONNECTORS_QUERY_TYPE.dbLevel}
      endValue={FILTER_CONNECTORS_QUERY_TYPE.codeLevel}
      selectStart={selectDbLevel}
      selectEnd={selectCodeLevel}
      startButtonTitle={'DB level'}
      endButtonTitle={'Code level'}
    />
  )
}

export default FilterConnectorsToggle
